// utils/UserUtils.ts

import { type UserType } from "@/generated/graphql"

export const hasRewards = (user: Partial<UserType>): boolean => {
  if (!user) return false
  const balance = user?.lastPointTransaction?.balance ?? 0
  return balance > 0 || false
}
